<template>
  <div>
    <h5 class="header-stripe">
      <span>{{$t('INDENT_CHANGE_REQUEST')}}</span>
      <div class="action">
        <Button type="secondary" size="mini" @click="$emit('cancelAction')">{{$t('INDENT_CANCEL')}}</Button>
        <Button type="primary" :disabled="!enableUpdate" size="mini" @click="update">
          {{$t('INDENT_UPDATE')}}</Button>
      </div>
    </h5>
    <div class="py-15">
      <Form class="form-default">
        <Row v-if="canChangeTrucktype">
          <Col :span="8">
            <FormItem :label="$t('INDENT_CHOOSE_VEHICLE')" required>
              <Select
                v-model="value"
                :placeholder="$t('INDENT_SELECT_VEHICLE_TYPE')"
                class="select-default"
                @change="selectVehicle"
                no-data-text="No Data">
                <Option
                  v-for="item in changeVehicles"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col :span="17">
            <FormItem :label="$t('INDENT_COMMENTS')" required>
              <Input type="textarea" :rows="3" v-model="comments" />
            </FormItem>
          </Col>
        </Row>
        <Row v-if="canChangeHillyRegion">
          <Col :span="17">
            <Checkbox v-model="isHillyRegion" @change="selectHillyRegion">{{$t('INDENT_HILLY_ROUTE')}}</Checkbox>
          </Col>
        </Row>
      </Form>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    vehicles: {
      type: Array,
      default: () => [],
    },
    canChangeTrucktype: {
      type: Boolean,
      default: false,
    },
    canChangeHillyRegion: {
      type: Boolean,
      default: false,
    },
    currentVehicle: {
      type: Object,
    },
  },
  data() {
    return {
      comments: '',
      value: '',
      isHillyRegion: false,
      changeVehicles: this.vehicles,
      noVehicleMessage: 'No Vehicle Change',
    };
  },
  computed: {
    isValidHillyRegionChange() {
      return this.canChangeHillyRegion && this.isHillyRegion;
    },
    isValidTruckChange() {
      return this.canChangeTrucktype && this.value.length > 0 && this.comments.length > 0;
    },
    isInvalidTruckChange() {
      if (!this.canChangeTrucktype) return false;
      return (this.value.length > 0 && this.comments.length === 0) ||
        (this.value.length === 0 && this.comments.length > 0);
    },
    enableUpdate() {
      if (this.isInvalidTruckChange) return false;
      return this.isValidTruckChange || this.isValidHillyRegionChange;
    },
    isEmptyChangeVehicle() {
      return this.canChangeTrucktype && this.value.length === 0 && this.comments.length === 0;
    },
  },
  methods: {
    update() {
      if (this.isValidTruckChange) {
        this.$emit('updateTruckType', {
          vehicle_id: this.value,
          comment: this.comments,
        });
      }

      if (this.isValidHillyRegionChange) {
        this.$emit('updateHillyRegion', {
          is_hilly_region: this.isHillyRegion,
        });
      }
    },
    selectHillyRegion() {
      if (this.isHillyRegion && this.isEmptyChangeVehicle) {
        this.changeVehicles.push(this.currentVehicle);
        this.value = this.currentVehicle.id;
        this.comments = this.noVehicleMessage;
      }
    },
    selectVehicle() {
      if (this.value !== this.currentVehicle && this.comments === this.noVehicleMessage) {
        this.comments = '';
      }
    },
  },
};
</script>
